module.exports = __webpack_public_path__ + "img/image 05.404a4866.png";